<section
  class="api-design text-white section grey-900"
  *ngIf="coreApiDesignData"
>
  <div class="section-container align-c">
    <h2 class="section-heading mar-b-32 white wid-75">
      {{ coreApiDesignData?.title }}
    </h2>
    <p class="section-description white mar-b-48">
      <span class="wid-50">
        {{ coreApiDesignData?.content.content?.[0].content?.[0].value }}
      </span>
    </p>

    <div class="tabs">
      <ng-container
        *ngFor="let tab of coreApiDesignData.component1; let i = index"
      >
        <label
          role="tab"
          [class.active]="i === activeTabIndex"
          (click)="switchTab(i)"
          [attr.id]="tab.id + '-tab'"
          [attr.aria-controls]="tab.id"
          [attr.aria-selected]="i === activeTabIndex ? 'true' : 'false'"
          >{{ tab.fields.title }}</label
        >
      </ng-container>
    </div>

    <div class="tab">
      <div class="section-core-api">
        <div class="core-api-data">
          <ng-container
            *ngFor="
              let explandable of coreApiDesignData.component1[activeTabIndex]
                .fields.component1;
              let id = index
            "
          >
            <div
              id="convertData-{{ id }}"
              class="api-data"
              [class.active]="id === activeDataCardIndex"
              (mouseover)="
                onMouseOverConvert(
                  id,
                  explandable?.fields?.richTextTitle?.content?.[0]?.content?.[0]
                    ?.value
                )
              "
            >
              <div class="api-data-header">
                <span class="semi-bold">
                  {{
                    explandable?.fields?.richTextTitle?.content?.[0]
                      ?.content?.[0]?.value
                  }}
                </span>
                <span
                  class="switch-icon"
                  [class.h]="id === activeDataCardIndex"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12 4C12.4418 4 12.8 4.35817 12.8 4.8V19.2C12.8 19.6418 12.4418 20 12 20C11.5582 20 11.2 19.6418 11.2 19.2V4.8C11.2 4.35817 11.5582 4 12 4Z"
                      fill="#359EB4"
                      [class.hidden]="id !== activeDataCardIndex"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 12C4 11.5582 4.35817 11.2 4.8 11.2H19.2C19.6418 11.2 20 11.5582 20 12C20 12.4418 19.6418 12.8 19.2 12.8H4.8C4.35817 12.8 4 12.4418 4 12Z"
                      fill="#359EB4"
                    />
                  </svg>
                </span>
              </div>
              <div class="api-data-content-wrapper">
                <p class="api-data-content">
                  {{
                    explandable?.fields?.description?.content?.[0]?.content?.[0]
                      ?.value
                  }}
                </p>
                <a
                  class="link mar-t-16"
                  href="{{
                    explandable?.fields?.button?.[0]?.fields?.redirectLink
                  }}"
                  target="{{
                    explandable?.fields?.button?.[0]?.fields?.actionType
                  }}"
                >
                  {{ explandable?.fields?.button?.[0]?.fields?.buttonText
                  }}<span class="arrow">&rarr;</span>
                </a>
                <div class="core-api-code-inside">
                  <div class="preview">
                    <img
                      loading="lazy"
                      height="294"
                      width="431"
                      src="https://verto-platform-assets.s3.eu-central-1.amazonaws.com/images/code-illustration.png"
                      alt=""
                    />
                    <button
                      class="action-btn"
                      (click)="
                        openCodeSnippetModal(
                          explandable?.fields?.richTextTitle?.content?.[0]
                            ?.content?.[0]?.value
                        )
                      "
                    >
                      View More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="core-api-code">
          <app-prism-code [apiType]="apiType"></app-prism-code>
        </div>
      </div>
    </div>
    <div class="landing-btn mar-t-24 justfy-c">
      <a
        href="{{ coreApiDesignData?.buttons[0].fields.redirectLink }}"
        target="{{ coreApiDesignData?.buttons[0].fields.actionType }}"
        class="btn btn-full"
      >
        {{ coreApiDesignData?.buttons[0].fields.buttonText }}
      </a>
    </div>
  </div>
</section>

<div *ngIf="showCustomPlanModal" class="code-modal">
  <div class="code-modal-body">
    <div class="title">
      <span>{{ apiModalTitle }}</span>
      <button (click)="closeCodeSnippetModal()" class="close">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="10" fill="#232E3A" />
          <path
            d="M9.33301 9.33301L22.6663 22.6663"
            stroke="#CACED1"
            stroke-width="1.25"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22.6663 9.33301L9.33301 22.6663"
            stroke="#CACED1"
            stroke-width="1.25"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <app-prism-code [apiType]="apiType"></app-prism-code>
  </div>
</div>
